import { Globals } from '@ortho-next/three-base';
import { QuadraticBezierCurve, Vector2 } from 'three';
import { Line2 } from "three/examples/jsm/lines/Line2.js";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { Consts } from '../../Utils/Consts.js';
import { Utils } from '../../Utils/Utils.js';
export class Arc extends Line2 {
    constructor(name, viewType, a, b, center, color, maxLength = 5) {
        super();
        this._curveComplexity = 40;
        this._scaleFactor = Consts.scaleFactorPoints;
        this.material = new LineMaterial({
            color: color,
            linewidth: 2,
            resolution: new Vector2(Globals.canvasContainer.clientWidth, Globals.canvasContainer.clientHeight),
        });
        this.interceptedByRaycaster = false;
        this.name = name;
        this.a = a;
        this.b = b;
        this.center = center;
        this.distance = maxLength;
    }
    update() {
        const distance = Math.min(this.distance * this._scaleFactor, this.a.distanceTo(this.center), this.b.distanceTo(this.center));
        const curvature = distance / 2;
        const ca = this.center.clone().add(this.a.clone().sub(this.center).setLength(distance));
        const cb = this.center.clone().add(this.b.clone().sub(this.center).setLength(distance));
        const middlePoint = cb.clone().lerp(ca, 0.5);
        const curvatureDir = middlePoint.clone().sub(this.center).setLength(curvature);
        middlePoint.add(curvatureDir);
        const curve = new QuadraticBezierCurve(new Vector2(ca.x, ca.y), new Vector2(middlePoint.x, middlePoint.y), new Vector2(cb.x, cb.y));
        const points = curve.getPoints(this._curveComplexity);
        const positions = Utils.parseVec2ArrayToNumber3Array(points);
        this.geometry.dispose();
        this.geometry = new LineGeometry().setPositions(positions);
    }
    updateResolution(width, height) {
        this.material.resolution.set(width, height);
    }
    dispose() {
        super.dispose();
        this.geometry.dispose();
        this.material.dispose();
    }
}
//# sourceMappingURL=Arc.js.map